/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { ShieldCheck, Loader2 } from "lucide-react";

export default function ConsentModal() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.consent?.accepte) return null;

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/me/consent", { accepte: true });
      setUser({ ...user, consent: { accepte: true, version: data.version } });
    } catch (e) {
      setUser({ ...user, consent: { accepte: true, version: "offline" } });
    }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[90] bg-[#0A1426]/70 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div data-testid="consent-modal" className="w-full max-w-[440px] bg-white rounded-t-3xl sm:rounded-3xl p-6 flex flex-col gap-4">
        <div className="w-14 h-14 rounded-2xl bg-[#F5F3EE] grid place-items-center text-[#2BA3A0]"><ShieldCheck size={30} /></div>
        <h2 className="font-[Fraunces] text-2xl font-bold text-[#0A1426]">Vos données de santé vous appartiennent</h2>
        <ul className="text-[14px] text-[#0A1426]/80 flex flex-col gap-2 leading-snug">
          <li>• Vos mesures (tension, humeur, exercices) servent uniquement à votre suivi et à votre équipe de soin.</li>
          <li>• Elles sont chiffrées, hébergées dans l'Union européenne, et conservées sur votre téléphone pour l'hors-ligne.</li>
          <li>• Vous pouvez <b>exporter</b> ou <b>supprimer</b> toutes vos données à tout moment depuis votre Profil.</li>
        </ul>
        <Link to="/privacy" data-testid="consent-privacy-link" className="text-[13px] font-bold text-[#2BA3A0] underline">Lire la politique de confidentialité</Link>
        <Button data-testid="consent-accept-btn" disabled={busy} onClick={accept} className="h-14 rounded-full bg-[#2BA3A0] hover:bg-[#0A1426] text-white font-bold text-base">
          {busy ? <Loader2 className="animate-spin" size={18} /> : "J'accepte et je continue"}
        </Button>
      </div>
    </div>
  );
}
